import { JSX, useState } from 'react';
import './Sidebar.css';
import burger from './../burger.svg';

function SidebarEntry({txt , ln}: {txt: string, ln: string}) {
    return (
        <a className="SidebarEntry" href={ln}>
            &#x27F6; {txt} <br/>
        </a>
    );
}

function SidebarContent() {
    const prefix = "/files/"
    const links = [
        {name: "Resume", link: "CV.pdf"},
        {name: "Bachelor's thesis", link: "Bsc.pdf"},
        {name: "Master's thesis", link: "Msc.pdf"}]
    
    return (
        <div className="SidebarContent">
            {links.map((ln, index) => (
                <SidebarEntry txt={ln.name} ln={prefix + ln.link}/>
            ))}
        </div>
    );
}

function Sidebar() {
    //const [SidebarWidth, SetSidebarWidth] = useState(window.innerWidth > 1080 ? OPEN_WIDTH : BASE_WIDTH)
    const [IsOpen, SetIsOpen] = useState(window.innerWidth > 1000 ? true : false)
    const [Cls, SetCls] = useState(IsOpen ? "SidebarOpen" : "SidebarClosed")
    
    function toggleOpen() {
        if (IsOpen) {
            SetCls("SidebarClosed");
        }
        else {
            SetCls("SidebarOpen");
        }
        SetIsOpen(!IsOpen);
    }
        
    function ToggleButton() {
        return (
            <>
            <button className="Button" onClick={toggleOpen}>
                <span className="SidebarTitle">
                    <img className="BurgerImage" src={burger} /> Links and stuff
                </span>
            </button>
            {IsOpen ? <SidebarContent /> : ""}
            </>
        )
    }
    
    return (
        <div className={Cls}>
            <ToggleButton />
        </div>
    );
}

export default Sidebar;